<template>
    <Toast />
    <h1>Planowane wyłączenia - panel mistrza</h1>
    <PlannedOutageMasterSearchCriteria ref="plannedOutageMasterSearchCriteria" v-model="searchCriteria"
                                       @update:modelValue="search" @confirmDelete="deleteSelectedOutages" />
    <PlannedOutageMasterTable ref="plannedOutageMasterTable" :search-criteria="searchCriteria" />
</template>

<script>
    import Toast from "primevue/toast";
    import {SearchCriteria} from "@/utils/SearchCriteria";
    import PlannedOutageMasterSearchCriteria from "./components/PlannedOutageMasterSearchCriteria";
    import PlannedOutageMasterTable from "./components/PlannedOutageMasterTable";

    export default {
        name: "PlannedOutageMasterView",

        components: {
            PlannedOutageMasterSearchCriteria,
            PlannedOutageMasterTable,
            Toast,
        },

        data() {
            return {
                searchCriteria: this.getClearSearchCriteria(),
            };
        },

        beforeMount() {
            SearchCriteria.loadCriteria(this);
        },

        mounted() {
            if (this.$route.params.showToast === "show") {
                this.$toast.add({
                    severity: "success",
                    summary: "Zapisano dane planowanego wyłączenia",
                    life: 2500,
                });
                this.$route.params.showToast = "hide";
            }
        },

        methods: {
            search() {
                SearchCriteria.updateUrl(this);

                this.$refs.plannedOutageMasterTable.search();
            },

            createdBy() {
                this.$router.push({name: "plannedOutageMasterCreate"});
            },

            clear() {
                this.searchCriteria = this.getClearSearchCriteria();
            },

            getClearSearchCriteria() {
                return {
                    id: null,
                    outageStart: null,
                    outageEnd: null,
                    deleted: false,
                    page: {
                        limit: 10,
                        offset: 0,
                        sortField: null,
                        sortOrder: null,
                    },
                };
            },

            deleteSelectedOutages() {
                this.$refs.plannedOutageMasterTable.deleteSelectedOutages();
            },
        },
    };
</script>

<style lang="less" scoped>
</style>
